/* istanbul ignore file */
exports.init = function (visitor, branch, context) {
  let banner_type_value,
    var2BannerTracking,
    multiBannerOn,
    {omniture, globalRegistry} = context,
    pageType = omniture && omniture.s && omniture.s.pageType;


  function branch_banner_type_listener (event, data) {

    let journey_data = data && data.journey_link_data,
      journey_tags = journey_data && journey_data.tags,
      journey_vars = journey_data && journey_data.data;

    banner_type_value = journey_tags && journey_tags[0];
    // var1 = true for variant 1, tags: var2Tracking on variant 2 journeys
    var2BannerTracking = (journey_tags && journey_tags[1]) === 'var2Tracking';
    multiBannerOn = journey_vars && journey_vars.var1;

    if (!banner_type_value) {
      banner_type_value = data && data.banner_id;
    }

    // This data is passed to branch dashboard and populates their tracking data
    branch.setBranchViewData({
      channel: 'Mobile Web',
      data: {
        url: location.href,
        sub2: (visitor && visitor.getMarketingCloudVisitorID(visitor.marketingCloudOrgID)), // eslint-disable-line
        sub1: banner_type_value
      }
    });
  }

  function _trackingCall (action) {
    let opt = {
      appInteraction: `NE: Branch: ${banner_type_value}: ${action}`,
      appInteractionType: `NE: Branch: ${banner_type_value}`,
      appInteractionPage: "NE: Branch",
      pageType: pageType
    };
    omniture && omniture.track(opt, true);
  }

  function branch_listener() {
    let banner = document.getElementById('branch-banner-iframe'),
      bannerContinue,
      bannerClose,
      bannerDownloadApp,
      bannerHeight,
      bannerContent,
      action;


    if (banner) {
      bannerHeight = banner ? banner.clientHeight : 0;
      bannerContent = banner.contentDocument ? banner.contentDocument : banner.contentWindow.document;
      if (bannerHeight > 200) {
        action = "Page view";
        if (var2BannerTracking) {
          action = "Page view from Variant 1";
        }
        _trackingCall(action);
        bannerContinue = bannerContent.getElementById('branch-banner-close2');
        if (bannerContinue) {
          bannerContinue.addEventListener('click', function() {
            action = "Continue to mWeb";
            _trackingCall(action);
          });
        }
      } else if (bannerHeight > 0) {
        // Add tag to indicate multiple journeys should show
        if (multiBannerOn) {
          branch.track(
            "did_show_variant_1"
          );
        }
        action = "Small Banner";
        if (var2BannerTracking) {
          action = "Small Banner from Variant 1";
        }
        _trackingCall(action);
      }

      bannerDownloadApp = bannerContent.getElementById('branch-mobile-action');
      bannerClose = bannerContent.getElementById('branch-banner-close1');

      if (bannerDownloadApp) {
        bannerDownloadApp.addEventListener('click', function() {
          action = "App Download";
          _trackingCall(action);
        });
      }

      if (bannerClose) {
        bannerClose.addEventListener('click', function() {
          action = "Close Banner";
          _trackingCall(action);
        });
      }
    }
  }

  branch.addListener('willShowJourney', branch_banner_type_listener);
  branch.addListener('didShowJourney', branch_listener);
  branch.init(
    'key_live_mofJnVNrG5BnZd6bjompgipgxCl6aZuh', // key
    {
      "open_app": true, //options
      "user_language": globalRegistry.getCurrentLocale()
    },
    function(err, data) {}); // eslint-disable-line
};
